import { Inject, Options, Prop, Vue, Watch } from "vue-property-decorator";
import { Category, PracticeView, SignatoryAtcsRequest, SignatoryRequest, SignatoryView, SolelyJointly } from "@/shared/modules/typescript-trustapi-client/models";
import LoadingSpinner from "@/shared/components/loading-spinner/index.vue";
import ModalBox from "@/shared/components/modal-box/index.vue";
import { TrustAPI } from "@/shared/modules/trust-api";
import { EventEmitter } from "events";
import store from "@/trust-atcs-app/store";
import V3DatePicker from 'vue3-datepicker';
import { ref } from 'vue'
import AlertBox from "@/shared/components/alert-box/index.vue";
import { debounce } from "lodash";
import { LawIdUserLsApiView } from "@/shared/modules/typescript-trustapi-client/models";
import ConfirmDialogue from '@/shared/components/confirm-dialogue/index.vue';
import { AppInsights } from "@/trust-atcs-app/appInsights";

@Options({
  props: {
    signatoryRequest: {},
    categories: Array,
    signatories: Array,
  },
  components: {
    ModalBox,
    LoadingSpinner,
    V3DatePicker,
    AlertBox,
    ConfirmDialogue
  }
})
export default class AddEditSignatoryModal extends Vue {
  private signatoryRequest!: SignatoryAtcsRequest;
  private signatories!: SignatoryView[];

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  @Inject({ from: 'solelyJointlyType', default: [] })
  private solelyJointlyType!: SolelyJointly[];

  @Inject({ from: 'categoriesType', default: [] })
  private categoriesType!: any[];

  @Prop({ default: false })
  private selectedPractice!: any;

  showAddEditModal!: boolean;

  // date picker
  private today = ref(new Date());

  private canSubmit = false;

  private showFullScreenFileViewer = false;
  private showStepper = false;
  private halfScreen = false;
  private show = false;
  private isLoadingData = false;
  private isFormDirty = false;
  private showCancelAlert = false;
  private editMode = false;

  private headerText = '';
  private line2Text = '';
  private existingLawId = false;
  private existingLsId = false;
  private existingName = false;

  private memberType = '1';
  private userList: LawIdUserLsApiView[] = [];
  private isOpen = false;
  private search = '';
  private arrowCounter = -1;
  private isSearching = false;
  private srchDebounced: any = null;

  private ai = new AppInsights;

  private selectUser(user: LawIdUserLsApiView) {
    this.isOpen = false;
    this.search = user.lawId + ' - ' + user.givenName + ' ' + user.surname;
    this.signatoryRequest.lawId = user.lawId;
    this.signatoryRequest.firstName = user.givenName;
    this.signatoryRequest.lastName = user.surname;
  }

  @Watch('search')
  private onKeywordChange(): void {
    if (this.search.length > 2 && this.userList.filter(x => x.lawId == this.search).length == 0) {
      // this.signatoryRequest.lawId = null;
      setTimeout(this.srchDebounced.cancel, 0);
      setTimeout(this.srchDebounced, 0);
    }
  }

  @Watch('signatoryRequest.signatoryTypeId')
  private onSignatoryTypeIdChange(): void {
    if (this.signatoryRequest.signatoryTypeId == 2) {
      this.signatoryRequest.solelyJointlyId = 2;
    }
  }

  mounted(): void {
    this.show = this.showAddEditModal;
    this.editMode = this.signatoryRequest.id !== 0;
    this.headerText = this.signatoryRequest.id === 0 ? 'Add new Authorised Signatory' : 'Edit Authorised Signatory';
    this.line2Text = this.signatoryRequest.firstName + ' ' + this.signatoryRequest.lastName;
    window.addEventListener('click', this.handleClickOutside);
    this.srchDebounced = debounce(() => {
      this.searchUser();
    }, 1000);
  }

  beforeUnmount(): void {
    window.removeEventListener('click', this.handleClickOutside);
  }

  private onArrowDown(evt: any) {
    if (this.arrowCounter < this.userList.length) {
      this.arrowCounter = this.arrowCounter + 1;
    }
  }

  private onArrowUp(): void {
    if (this.arrowCounter > 0) {
      this.arrowCounter = this.arrowCounter - 1;
    }
  }

  private onEnter() {
    if (this.userList.length > 0) {
      this.selectUser(
        this.userList[this.arrowCounter === -1 ? 0 : this.arrowCounter]
      );
    }
    this.isOpen = false;
  }

  private handleClickOutside(evt: any): void {
    if (this.$el === (evt.target)) {
      this.isOpen = false;
      this.arrowCounter = -1;
    }
  }

  private highlightWord(word: string): string {
    try {
      const regex = new RegExp('(' + this.search + ')', 'ig');
      return word.replace(regex, '<mark>$1</mark>');
    } catch (err) {
      return word;
    }
  }

  private mandatoryCheck() {
    this.isFormDirty = true;
    if (this.signatoryRequest.signatoryTypeId == 1) {
      const _lawId: boolean = this.signatoryRequest.lawId.trim() !== '';
      const _name: boolean = this.signatoryRequest.firstName.trim() !== '';
      const _catId: boolean = this.signatoryRequest.categoryId !== 0;
      const _sj: boolean = this.signatoryRequest.signatoryTypeId !== 0;
      this.canSubmit = _lawId && _name && _catId && _sj;
    } else {
      const _firstName: boolean = this.signatoryRequest.firstName.trim() !== '';
      const _lastName: boolean = this.signatoryRequest.lastName.trim() !== '';
      const _sj: boolean = this.signatoryRequest.signatoryTypeId !== 0;
      const _catId: boolean = this.signatoryRequest.categoryId !== 0;
      const _solelyJointly: boolean = this.signatoryRequest.solelyJointlyId == 2;
      this.canSubmit = _firstName && _lastName && _catId && _sj && _solelyJointly;
    }

  }

  get from(): Date {
    return this.signatoryRequest.commencedDate;
  }

  private async searchUser() {
    const _body = {
      practiceCoreId: this.selectedPractice.practiceCoreId,
      keyword: this.search
    }

    try {
      this.isSearching = true;
      const resp: any = await this.apiService.PeopleAtcsApi?.apiV2AtcsPeopleGetSearchLawIdUsersPost(_body);
      this.userList = resp.data.data as LawIdUserLsApiView[];
      this.isOpen = this.userList.length > 0;
    } catch (err) {
      this.isOpen = false;
    } finally {
      this.isSearching = false;
    }
  }

  private cancelClicked() {
    if (this.isFormDirty) {
      this.showCancelAlert = true;
    } else {
      this.closeModal();
    }
  }

  private yesClicked() {
    this.closeModal();
  }

  private closeModal(): void {
    this.$emit('closeModal');
  }

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  private submit(): void {
    this.isLoadingData = true;
    this.$emit('statusChange', this.isLoadingData);
    this.signatoryRequest.practiceCoreId = this.selectedPractice.practiceCoreId;
    this.apiService.PeopleAtcsApi?.apiV2AtcsPeopleSaveSignatoryPost({
      practiceCoreId: this.selectedPractice.practiceCoreId,
      signatoryRequest: this.signatoryRequest,
      updatingKey: this.signatoriesUpdatingKey
    })
      .then(res => {
        setTimeout(() => {
          this.$emit('dataChangedSuccessfully', res);
          this.isLoadingData = false;
          this.closeModal();
        }, 250);
        if (this.signatoryRequest.id > 0) {
          this.eventCtrl.emit('show-snackbar', 'success', 'Record updated successfully..');
        } else {
          this.eventCtrl.emit('show-snackbar', 'success', 'Record is added successfully..');
        }
      })
      .catch(err => {
        console.log(err);
        this.eventCtrl.emit('show-snackbar', 'error', 'Error on submitting authorised signatory');
        this.isLoadingData = false;
        this.$emit('statusChange', this.isLoadingData);
      })
  }

  private deleteAuthroisedSignatory(): void {
    const _confirm: any = this.$refs.confirmTerminateDialogue;
    _confirm.show({
      title: 'Delete Authorised Signatory',
      message: 'Are you sure you want to delete this authorised signatory?',
      okButton: 'Confirm',
      cancelButton: 'Cancel',
    }).then((res: any) => {
      if (res) {
        this.isLoadingData = true;
        this.$emit('statusChange', this.isLoadingData);
        this.apiService.PeopleAtcsApi?.apiV2AtcsPeopleDeleteSignatoryPost({
          practiceCoreId: this.selectedPractice.practiceCoreId,
          signatoryId: this.signatoryRequest.id,
          updatingKey: this.signatoriesUpdatingKey
        })
          .then((resp: any) => {
            this.$emit('dataChangedSuccessfully', res);
            this.eventCtrl.emit('show-snackbar', 'success', 'Authorised signatory deleted');
            this.closeModal();
          })
          .catch((err: any) => {
            this.eventCtrl.emit('show-snackbar', 'error', 'Unable to delete Authorised Signatory');
            this.ai.trackException('Unable to delete Authorised Signatory: ' + err);
          }).finally(() => {
            this.isLoadingData = false;
            this.$emit('statusChange', this.isLoadingData);
          });
      }
    });
  }

  get signatoriesUpdatingKey(): string {
    return store.getters.getSignatoriesUpdatingKey;
  }

}

